module.exports = __webpack_public_path__ + "front/img/u5.4c84e06f.jpg";